import { makeStyles } from "@mui/styles";
import { Typography } from "@mui/material";
const offsetStyle = "72px";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    height: "100%",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      height: `calc(100vh - ${offsetStyle})`,
      minHeight: `calc(100vh - ${offsetStyle})`,
    },
  },
  headerIcon: {
    marginTop: "4rem",
  },
  header: {
    fontWeight: "bold",
    fontSize: 30,
    marginTop: "2.5rem",
    color: "#ffffff",
  },
  courseCodeHeader: {
    color: "#ffffff",
    fontWeight: "bold",
    fontSize: 30,
  },
  subHeader: {
    fontSize: 16,
    marginTop: "1rem",
    marginBottom: "2rem",
    maxWidth: 582,
  },
}));

interface RegMessageScreenProps {
  header?: string;
  subHeader?: any;
  headerIcon?: any;
  hideBackground?: boolean;
  children?: any;
}

const opaqueStyle = {
  backgroundColor: "#fafafa",
  color: "#000000E6",
};

const defaultStyle = {
  backgroundColor: "unset",
  color: "#FFFFFF",
};

export const RegistrationMessageScreen = (props: RegMessageScreenProps) => {
  const { header = "", subHeader = "", headerIcon = "", hideBackground = false } = props;
  const classes = useStyles();

  return (
    <div
      className={classes.container}
      style={hideBackground ? opaqueStyle : defaultStyle}>
      <div className={classes.headerIcon}>{headerIcon}</div>
      <Typography
        component="h5"
        variant="h5"
        className={
          header === "Join your class" ? classes.courseCodeHeader : classes.header
        }>
        {header}
      </Typography>
      <Typography
        component="main"
        color="#FFF"
        className={classes.subHeader}
        sx={{ fontWeight: 400 }}>
        {subHeader}
      </Typography>
      {props.children}
    </div>
  );
};
